export default __webpack_public_path__ + "static/media/Snd3.0614f81d.mp3";